export var IdPendingInventoryRewardType;
(function (IdPendingInventoryRewardType) {
    IdPendingInventoryRewardType[IdPendingInventoryRewardType["Resource"] = 0] = "Resource";
    IdPendingInventoryRewardType[IdPendingInventoryRewardType["Building"] = 1] = "Building";
    IdPendingInventoryRewardType[IdPendingInventoryRewardType["Package"] = 2] = "Package";
    IdPendingInventoryRewardType[IdPendingInventoryRewardType["Picture"] = 3] = "Picture";
})(IdPendingInventoryRewardType || (IdPendingInventoryRewardType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/IdPendingInventoryRewardType.ts
// module id = 882
// module chunks = 3